import { AxiosError } from 'axios';

import { Interceptor } from 'app/api/interceptor/Interceptor';
import { NetworkException } from 'app/api/exception/NetworkException';

export class NetworkErrorInterceptor implements Interceptor {
    process(error: AxiosError): void {
        if (error.code === AxiosError.ERR_NETWORK) {
            throw new NetworkException();
        }
    }
}
